module.exports = __webpack_public_path__ + "static/media/MN.96cf0073.svg";